// Şube Fiyatları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.branchPricesPage';

export const branchPricesPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Şube Fiyatları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bir şubede ürünlerin şubeye özel alış, satış, liste ve paket fiyatlarını bu sayfada görür ve düzenlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    filters: t(`${G}.regions.filters`, 'Şube ve arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Kopyala / Yeni ekle'),
    table: t(`${G}.regions.table`, 'Fiyat listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Şubeyi seçin'),
      text: t(`${G}.s1.text`, 'Önce "Şube Seçin *" kutusundan bir şube seçin; liste o şubeye tanımlı fiyatlarla dolar. Sonra "Ürün Ara..." ile ürün adı, stok kodu veya kategoriye göre arayın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube yöneticisi olarak girdiyseniz şube kendi şubenize kilitlidir ("Şube (Kilitli)").'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni şube fiyatı ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Şube Fiyatı Ekle" ile önce ürünü seçin; ardından açılan şube fiyatı penceresinde (kendi rehberi vardır) seçili şube için fiyatı girin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube yöneticisi yalnız mevcut fiyatları güncelleyebilir; yeni fiyat ekleme ve kopyalama ana yöneticiye aittir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Fiyatları başka şubeye kopyalayın'),
      text: t(`${G}.s3.text`, '"Başka Şubeye Kopyala" bu şubenin tüm fiyatlarını seçeceğiniz hedef şubeye toplu kopyalar. Ön izlemede kaç fiyatın ekleneceğini ve kaçının atlanacağını görürsünüz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Hedef şubede zaten fiyatı olan ürünler atlanır; mevcut fiyatların üzerine yazılmaz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Fiyatı hücreden düzenleyin'),
      text: t(`${G}.s4.text`, 'Alış, Satış, Liste veya Paket Fiyatı hücresine tıklayın; açılan pencerede yeni fiyatı yazıp "Kaydet"e (veya Enter) basın. Fiyat negatif olamaz. Değişiklikler kullanıcı ve şube bilgisiyle fiyat değişiklik kaydına yazılır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Alış fiyatında şubeye özel değer yoksa ürün kartındaki alış fiyatı gösterilir; tıklayıp girerseniz şubeye özel alış fiyatı olur.'),
        t(`${G}.s4.tip2`, '"Ürün kartı fiyatını kullan" şubeye özel alış fiyatını kaldırır; ürün kartındaki alış fiyatı yeniden geçerli olur.'),
        t(`${G}.s4.tip3`, 'Satış fiyatı tanımlı olmayan satırda (ürün kartı) ürün kartındaki satış fiyatı görünür; tıklayıp girerseniz şubeye özel satış fiyatı olur.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Durum: satışta hangi fiyat geçerli?'),
      text: t(`${G}.s5.text`, 'Durum sütunu, ürünün "Şube Fiyatlarını Kullan" ayarını gösterir. Aktif ise satışta şubenin fiyatı uygulanır; Pasif ise şube fiyatı olsa bile ürün kartındaki satış fiyatı kullanılır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Bu ayar ürün bazındadır; değiştirdiğinizde ürünün tüm şubeleri etkilenir.'),
        t(`${G}.s5.tip2`, 'Ana yönetici Durum etiketine tıklayarak ürünün şube fiyatı penceresini açar ve ayarı değiştirir; şube yöneticisi yalnız görür.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Listeyi yenileyin, sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Yenile düğmesi listeyi tazeler; liste uzunsa alttaki sayfalama ile ilerleyin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
